import React from 'react';
import GroceryListApp from './components/GroceryListApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <GroceryListApp />
    </div>
  );
}

export default App;